import { Injectable, inject } from '@angular/core';
import { ComponentStoreFactory } from '../../../../../shared/store/common/component-store.factory';
import { PersonService } from '../../../../service/person.service';
import { Store } from '@ngrx/store';
import {
    selectPerson,
} from '../../../../store/person/person.selectors';
import {
    MedicationGridObject,
    PersonGridItemObject,
} from '@it2go/types';
import { map } from 'rxjs/operators';

interface State {
    medications: MedicationGridObject | null;
}

const defaultState: State = {
    medications: null,
};

@Injectable()
export class VoucherDetailSituationFtStore extends ComponentStoreFactory<
    State,
    PersonService
> {
    address$ = this.globalStore!.select(selectPerson).pipe(
        map(
            (person: PersonGridItemObject | null) =>
                person?.addresses?.find((it) => it.serviceAddress)?.address,
        ),
    );

    constructor() {
        super(defaultState, inject(Store), inject(PersonService));
    }
}
